<template>
  <div class="bkl">
    <div class="bg1 flex align-center justify-center flex-direction" :style="{height:height}">
      <div class="title">从医院到家庭</div>
      <div class="sub-title">依靠布咳乐平台解决全病程服务</div>
    </div>
    <div class="platform">
      <div class="container">
        <div class="row">
          <div class="headline img-100 flex flex-direction align-center">
            <div class="title">布咳乐平台</div>
            <div class="introduction">实现数据驱动、疾病行为分析和物联网智能应用解决方案服务商</div>
          </div>

          <div
            class="col-md-4 flex align-center flex-direction platform-item"
            v-for="(item,index) in platformList"
            :key="index"
          >
            <div class="img">
              <img class="img-100" :src="item.img" alt srcset />
            </div>
            <div class="name">{{item.name}}</div>
            <div class="con">{{item.con}}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="platform data b-f">
      <div class="container">
        <div class="row">
          <div class="headline img-100 flex flex-direction align-center">
            <div class="title">数据，是一切分析的前提</div>
            <div class="introduction">实现数据驱动四部曲</div>
          </div>

          <div class="col-6 col-md-3 date-img-item">
            <img class="img" src="@/assets/img/xiangmu/data1@2x.png" alt srcset />
            <img class="img-104 display-n" src="@/assets/img/xiangmu/104@2x.png" alt srcset />
          </div>
          <div class="col-6 col-md-3 date-img-item">
            <img class="img" src="@/assets/img/xiangmu/data2@2x.png" alt srcset />
            <img class="img-104 display-n" src="@/assets/img/xiangmu/104@2x.png" alt srcset />
          </div>

          <div class="col-6 col-md-3 date-img-item">
            <img class="img" src="@/assets/img/xiangmu/data3@2x.png" alt srcset />
            <img class="img-104 display-n" src="@/assets/img/xiangmu/104@2x.png" alt srcset />
          </div>

          <div class="col-6 col-md-3 date-img-item">
            <img class="img" src="@/assets/img/xiangmu/data4@2x.png" alt srcset />
          </div>

          <div class="container-fluid data-list">
            <div class="row">
              <div class="col-md-6 data-item" v-for="(item,index) in dataList" :key="index">
                <span class="title">{{item.title}}</span>
                <div class="con">{{item.con}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      height: "",
      platformList: [
        {
          img: require("../../assets/img/xiangmu/icon1@2x.png"),
          name: "布咳乐分析",
          con:
            "针对患者的雾化器使用行为分析平台。实时数据采集、建模、分析，驱动医生诊断、家长监控与医疗科研数据支持。"
        },
        {
          img: require("../../assets/img/xiangmu/icon2@2x.png"),
          name: "布咳乐用户画像",
          con:
            "全端采集用户行为数据，整合业务数据等多种数据源，帮助医生构建体系化用户标签图书馆，输出用户画像，赋能业务实现用户精细化治疗。"
        },
        {
          img: require("../../assets/img/xiangmu/icon3@2x.png"),
          name: "布咳乐智能运营",
          con:
            "集活动创建、执行、管理、反馈、迭代为一体的自动化平台，能够通过用户行为、属性、标签等数据筛选受众，实现目标人群的精准触达，提升关键指标和运营效率。"
        },
        {
          img: require("../../assets/img/xiangmu/icon4@2x.png"),
          name: "布咳乐智能推荐",
          con:
            "基于用户行为分析的全流程智能推荐系统。实现对用户“千人千面”的个性化内容推荐，改善用户体验，持续提升核心业务指标。"
        },
        {
          img: require("../../assets/img/xiangmu/icon5@2x.png"),
          name: "布咳乐客景",
          con:
            "基于行为数据的患者全生命周期分析系统。对患者分级洞悉客群健康状态，预知患者病情风险，保障患者治疗周期安全与效果。"
        }
      ],
      dataList: [
        {
          title: "采集数据",
          con:
            "这里有呼吸疾病医疗业务中的多种数据来源，包括了终端（Web、H5、硬件）的用户行为，后端服务器日志（Log）和业务数据（DataBase）。我们可根据治疗行为分析治疗情况与后续需求，高效地采集散落各处的基础数据，沉淀患者数据资产。"
        },
        {
          title: "数据接入与储存",
          con:
            "多种埋点方式，确保布咳乐分析提供给医生适合患者与科研需求的数据接入方案。确保任何医生都可以便捷地接入布咳乐系统。数据实时导入，格式从此统一、完备。"
        },
        {
          title: "可视化查询与分析",
          con:
            "一切准备就绪，只需要选择需要的分析模型，点选关注的属性和指标，一键便可查询分析结果，数据实时更新、秒级响应，让数据分析达到前所未有的灵活、简单。"
        },
        {
          title: "驱动决策和产品智能",
          con:
            "分析业务表现从而驱动决策，这只挖掘了数据的部分价值。随着人工智能快速发展，在布咳乐分析为你打造的基础数据平台上，叠加学习算法，反馈到产品与治疗方法，从而驱动产品智能，让你的数据发挥更大的能量。"
        }
      ]
    };
  },
  beforeMount() {
    const that = this;
    var w = document.documentElement.clientWidth || document.body.clientWidth;
    var h = document.documentElement.clientHeight || document.body.clientHeight;
    if (w > 992) {
      that.height = h + "px";
    } else {
      that.height = h / 2 + "px";
    }
    window.onresize = () => {
      var w = document.documentElement.clientWidth || document.body.clientWidth;
      var h =
        document.documentElement.clientHeight || document.body.clientHeight;
      if (w > 992) {
        that.height = h + "px";
      } else {
        that.height = h / 2 + "px";
      }
    };
  }
};
</script>
<style lang="scss" scoped>
.bg1 {
  background-color: transparent;
  background-image: url("../../assets/img/xiangmu/bg1.png");
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  color: #fff;

  .title {
    font-size: 56px;
  }
  .sub-title {
    font-size: 48px;
  }
}
.b-f {
  background-color: #f5f5f5;
}
.platform {
  padding-bottom: 90px;
  .headline {
    padding: 90px 0;

    .title {
      font-size: 48px;
    }
    .introduction {
      font-size: 26px;
      padding: 10px;
    }
  }
  .platform-item {
    margin-bottom: 20px;
    .img {
      width: 160px;
    }
    .name {
      font-size: 18px;
    }
    .con {
      font-size: 14px;
      color: #616161;
      text-align: left;
    }
  }
}

.date-img-item {
  .img {
    width: 146px;
  }
  .img-104 {
    width: 50px;
    height: 10px;
    margin-left: 45px;
  }
}

.data-list {
  margin-top: 60px;

  .data-item {
    padding-bottom: 20px;
  }

  .title {
    font-size: 20px;
    position: relative;
    margin-bottom: 20px;
    display: inline-block;

    &:after {
      content: "";
      display: block;
      position: absolute;
      top: 30px;
      width: 100%;
      height: 0;
      left: 0;
      border-bottom: 3px solid #0c948a;
      border-radius: 2px;
    }
  }
  .con {
    color: #787878;
    font-size: 14px;
    text-align: left;
  }
}

@media (max-width: 992px) {
  .date-img-item {
    margin-bottom: 10px;
    .display-n {
      display: none;
    }
  }
}

@media (max-width: 576px) {
  .bg1 {
    .title {
      font-size: 30px;
    }
    .sub-title {
      font-size: 22px;
    }
  }

  .platform {
    padding-bottom: 30px;
    .headline {
      padding: 30px 0;

      .title {
        font-size: 30px;
      }
      .introduction {
        font-size: 20px;
        padding: 10px;
      }
    }
  }
}
</style>
